import axios from 'axios'
export default {
    namespaced: true,

    state: {
        modelos: []
    },

    mutations: {
        STORE_MODELOS(state, result){
            state.modelos = result
        }
    },

    getters: {
        ModeloAssinaturas: state => state.modelos.filter(modelo => !modelo.mensagem_avulsa),
        ModeloMensagensAvulsas: state => state.modelos.filter(modelo => modelo.mensagem_avulsa)
    },

    actions:{
        listaModelos(context){
            axios('adm/mensagens').then(res => {
                context.commit("STORE_MODELOS", res.data)
            })
        }
    }
}